<template>
  <div
    class="
      sf-layer-border sf-layer-rounded
      tw-bg-white
      [&>*:first-child>div]:tw-rounded-t-lg
      [&>*:last-child>div]:tw-rounded-b-lg
    "
  >
    <slot />
  </div>
</template>
